import React from 'react';

export default function ConfirmDialog({ open, title, message, confirmLabel='Confirm', danger=true, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onCancel()}>
      <div className="modal" style={{ maxWidth: 380 }}>
        <div className="modal-title">{title}</div>
        {message && <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16 }}>{message}</p>}
        <div className="modal-actions">
          <button onClick={onCancel}>Cancel</button>
          <button className={danger ? 'btn-danger' : 'btn-primary'} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
